import { IModelEntity } from '../interfaces/model.entity.interface';

export interface ICredentialsEntity extends IModelEntity {

    email: string;
    password: string;
    username: string;

}

export interface IUserProfileEntity extends IModelEntity {

    email: string;
    firstName: string;
    lastName: string;
    phoneMobile: string;
    phonePrivate: string;
    phoneWork: string;

    credentials: ICredentialsEntity;

}
